import React from "react";

import { SocialMedia } from "models/Social";
import { IPaperCVContent } from "../PaperCVContent";

interface ISocialMediaProps {
  socialMedia: SocialMedia;
  content: IPaperCVContent;
}

export const MediaLinks: React.FC<
  React.PropsWithChildren<ISocialMediaProps>
> = ({ socialMedia: { website }, content }) => (
  <div className="c-paper-cv__media-links">
    <b>{content.webSiteLabel}</b>
    <span>{website}</span>
  </div>
);
